import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login-heading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IInput = _resolveComponent("IInput")!
  const _component_Message = _resolveComponent("Message")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.loginText), 1),
    _createElementVNode("form", {
      class: "login-form",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitLoginForm && _ctx.submitLoginForm(...args)), ["prevent"]))
    }, [
      _createVNode(_component_IInput, {
        placeholder: _ctx.t('login.user_name'),
        name: "username",
        modelValue: _ctx.formFields.userName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formFields.userName) = $event)),
        valid: _ctx.isValid,
        class: "name-input"
      }, null, 8, ["placeholder", "modelValue", "valid"]),
      _createVNode(_component_IInput, {
        placeholder: _ctx.t('login.password'),
        name: "password",
        type: "password",
        valid: _ctx.isValid,
        modelValue: _ctx.formFields.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formFields.password) = $event))
      }, null, 8, ["placeholder", "valid", "modelValue"]),
      _createVNode(_component_Message, { text: _ctx.errorMessage }, null, 8, ["text"]),
      _createElementVNode("div", {
        class: _normalizeClass({ 'invalid-submission': !this.isSubmissionValid })
      }, [
        _createVNode(_component_SubmitButton, {
          text: _ctx.t('login.log_in')
        }, null, 8, ["text"])
      ], 2)
    ], 32)
  ]))
}